import { userFeedBack } from "../user-feedback/json";
import { Model } from "@fullstory/form-core";
import { Survey } from "@fullstory/form-react";
import * as SurveyTheme from "@fullstory/form-core/themes";
import "@fullstory/form-core/form-core.min.css";
import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { FullStory } from "@fullstory/browser";
import { FaTimes } from "react-icons/fa";

export const UserFeedBack = () => {
    const [show, setShow] = useState<boolean>(false);
    const [surveyModel, setSurveyModel] = useState<any>(null);

    useEffect(() => {
        const initializeSurvey = async () => {
            try {
                const model = new Model(userFeedBack);
                await model.createBlockList();
                model.applyTheme(SurveyTheme.PlainLightPanelless);
                model.onComplete.add(sender => {
                    close();
                    FullStory("trackEvent", {
                        name: "User Feedback Survey",
                        properties: sender.data
                    });
                });

                setSurveyModel(model);
            } catch (error) {
                console.error("Error initializing survey:", error);
            }
        };

        initializeSurvey();
    }, []);

    useEffect(() => {
        if (surveyModel !== null) {
            setTimeout(() => {
                setShow(true);
            }, 1000);
        }
    }, [surveyModel]);

    const close = () => {
        setShow(false);
    };

    return (
        <Modal open={show} onBackdropClick={close}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "40vw",
                    position: "absolute" as "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }}
            >
                <div style={{ borderRadius: "5px", padding: "10px", backgroundColor: "white" }}>
                    <div>
                        <button
                            id="close-button"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer"
                            }}
                            onClick={() => close()}
                        >
                            <FaTimes size={20} />
                        </button>
                    </div>
                    {surveyModel !== null && <Survey model={surveyModel} />}
                </div>
            </Box>
        </Modal>
    );
};
